/**
 * The enum of environment.
 */
export var Environment;
(function (Environment) {
    Environment["BACKEND"] = "BACKEND";
    Environment["BROWSER"] = "BROWSER";
    Environment["BROWSER_NON_AUTH"] = "BROWSER_NON_AUTH";
    Environment["DESKTOP"] = "DESKTOP";
    Environment["DESKTOP_NON_AUTH"] = "DESKTOP_NON_AUTH";
    Environment["DEVICE"] = "DEVICE";
    Environment["DEVICE_NON_AUTH"] = "DEVICE_NON_AUTH";
})(Environment || (Environment = {}));
//# sourceMappingURL=environment.js.map